import React from 'react';
import { SearchLocationInput } from 'components';
import { Card, Row, Col, Button, FloatingLabel, Form } from 'react-bootstrap';

const Forms = props => {
  const { permission, fieldChange, onSubmit, units, setLocation } = props;

const formatCpfOrCnpj = (value) => {
  if (!value) return value;

  const onlyDigits = value.replace(/\D/g, '');

  if (onlyDigits.length === 11) {
    // Formatar como CPF: 000.000.000-00
    return onlyDigits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }

  if (onlyDigits.length === 14) {
    // Formatar como CNPJ: 00.000.000/0000-00
    return onlyDigits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }

  // Se não for CPF nem CNPJ válido, retorna sem formatação
  return onlyDigits;
};

  const handleCNPJChange = (event) => {
    const rawValue = event.target.value;
    const formattedCNPJ = formatCpfOrCnpj(rawValue);
    fieldChange(event, 'cnpj', formattedCNPJ);
  };

  const handlePhoneChange = (event) => {
    const rawValue = event.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    let formattedValue = rawValue;

    if (rawValue.length > 10) {
      formattedValue = `(${rawValue.slice(0, 2)}) ${rawValue.slice(2, 7)}-${rawValue.slice(7, 11)}`;
    } else if (rawValue.length > 6) {
      formattedValue = `(${rawValue.slice(0, 2)}) ${rawValue.slice(2, 6)}-${rawValue.slice(6)}`;
    } else if (rawValue.length > 2) {
      formattedValue = `(${rawValue.slice(0, 2)}) ${rawValue.slice(2)}`;
    }

    fieldChange(event, 'fone', formattedValue);
  };

  return (
    <Card className='mt-3 p-3 g-2'>
      <Row className='g-2'>
        <Col>
          <FloatingLabel
            controlId="floatingName"
            label="Nome da Unidade"
            className="mb-3"
          >
            <Form.Control
              type="text"
              placeholder="Nome da Unidade"
              name="name"
              onChange={event => fieldChange(event, 'name', event.target.value)}
              value={units.name}
              maxLength={100}
            />
          </FloatingLabel>

          <FloatingLabel controlId="floatingCNPJ" label="CPF/CNPJ" className="mb-3">
            <Form.Control
              type="text"
              placeholder="CPF/CNPJ"
              name="cnpj"
              autoComplete="off"
              onChange={handleCNPJChange}
              value={units.cnpj}
              maxLength={18}
            />
          </FloatingLabel>

          <SearchLocationInput
            setLocation={setLocation}
            addr={units.address}
          />
        </Col>

        <Col>

          <FloatingLabel
            controlId="floatingNContract"
            label="Número do contrato"
            className="mb-3"
          >
            <Form.Control
              type="text"
              placeholder="Número do contrato"
              name="ncontract"
              autoComplete="off"
              onChange={(event) => fieldChange(event, 'ncontract', event.target.value)}
              value={units.ncontract}
              maxLength={45}
            />
          </FloatingLabel>

          <FloatingLabel
            controlId="floatingPhone"
            label="Telefone"
            className="mb-3"
          >
            <Form.Control
              type="text"
              placeholder="Telefone"
              name="fone"
              autoComplete="off"
              onChange={(event) => handlePhoneChange(event)}
              value={units.fone}
              maxLength={15}
            />
          </FloatingLabel>

          <FloatingLabel
            controlId="floatingEmail"
            label="E-mail"
            className="mb-3"
          >
            <Form.Control
              type="email"
              placeholder="E-mail"
              name="email"
              autoComplete="off"
              onChange={(event) => fieldChange(event, 'email', event.target.value)}
              value={units.email}
              maxLength={100}
            />
          </FloatingLabel>

        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            onClick={() => { onSubmit() }}
            variant="success"
            disabled={!permission?.units?.write}
          >
            Salvar
          </Button>

          <Button
            onClick={() => { window.history.back() }}
            variant="secondary"
            className='mx-2'
          >
            Cancelar
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default Forms;
